import React, { Component } from 'react';
import Sidenavigation from '../layouts/Sidenavigation';
import Topnavigation from '../layouts/Topnavigation';
import Addcategoryorder from '../sections/Addproduct/Addcategoryorder'
import Quickbar from '../layouts/Quickbar';

class Categoryorder extends Component {
    render() {
        return (
            <div className="ms-body ms-aside-left-open ms-primary-theme ms-has-quickbar">
                <Sidenavigation />
                <main className="body-content">
                    <Topnavigation />
                    <Addcategoryorder/>
                </main>
                <Quickbar />
            </div>
        );
    }
}

export default Categoryorder;